import { render, staticRenderFns } from "./PoisThumb.vue?vue&type=template&id=f4c3ef38&scoped=true&"
import script from "./PoisThumb.vue?vue&type=script&lang=js&"
export * from "./PoisThumb.vue?vue&type=script&lang=js&"
import style0 from "./PoisThumb.vue?vue&type=style&index=0&id=f4c3ef38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c3ef38",
  null
  
)

export default component.exports